import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { AdvancingTemplateNewSection } from "../AdvancingTemplateNewSection";
import { useLoaderData } from "react-router";

const AdvancingTemplateNewApp = () => {
  const viewModel = useLoaderData<server.viewmodel.AdvancingTemplateFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <AdvancingTemplateNewSection
            allFormSections={viewModel.formSections}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <GeneralOptionsPanel
            links={[{
              text: RESX.Buttons.ListView,
              href: viewModel.listUrl,
              visible: true
            }]}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default AdvancingTemplateNewApp;